import React from 'react';
import PageLayout, { PageVariant } from './PageLayout';
import StickyContextProvider from './StickyContext';
import PageMeta, { IPageMetaProps } from 'app/components/common/PageMeta';
import { CallbackRef } from 'app/utils/react';

export { PAGE_BASE_STYLE, PAGE_WIDE_STYLE } from './PageLayout';

interface IPageProps extends IPageMetaProps {
  children?: React.ReactNode;
  variant?: PageVariant;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  getRef?: CallbackRef;
}

/**
 * Page component, will specify title and description if specified.
 */
const Page: React.FC<IPageProps> = ({
  children,
  variant,
  header,
  footer,
  getRef,
  ...pageMetaProps
}) => {
  return (
    <PageMeta {...pageMetaProps}>
      <StickyContextProvider>
        <PageLayout getRef={getRef} variant={variant} header={header} footer={footer}>
          {children}
        </PageLayout>
      </StickyContextProvider>
    </PageMeta>
  );
};

export default Page;
